/**
 * @generated SignedSource<<6f23db545527e2b18812ee104c36e2dc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MutationsAddSchemaMutation$variables = {
  json: any;
};
export type MutationsAddSchemaMutation$data = {
  readonly addSchema: {
    readonly _id: number;
    readonly versionAt: {
      readonly referencingSchemas: ReadonlyArray<{
        readonly _id: number;
      }>;
    } | null;
  };
};
export type MutationsAddSchemaMutation = {
  response: MutationsAddSchemaMutation$data;
  variables: MutationsAddSchemaMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "json"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "json",
        "variableName": "json"
      }
    ],
    "concreteType": "Schema",
    "kind": "LinkedField",
    "name": "addSchema",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "SchemaVersion",
        "kind": "LinkedField",
        "name": "versionAt",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Schema",
            "kind": "LinkedField",
            "name": "referencingSchemas",
            "plural": true,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MutationsAddSchemaMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MutationsAddSchemaMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "f0236dc211ce09f04b138151f79e010a",
    "id": null,
    "metadata": {},
    "name": "MutationsAddSchemaMutation",
    "operationKind": "mutation",
    "text": "mutation MutationsAddSchemaMutation(\n  $json: JsonScalar!\n) {\n  addSchema(json: $json) {\n    _id\n    versionAt {\n      referencingSchemas {\n        _id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c95febba502e34e5b86bc20b725fad01";

export default node;
